export const BELONG_RESULT_TEXT = `You will make your own decisions in your Next Great Adventure and want to equip you now to do so.`;
export const BELONG_SUGGESTION_TEXT = (attribute?: string) =>
  `Based on your results, we recommend this sample challenge to get you started on your Next Great Adventure!`;
export const BELONG_RESULT_DESCRIPTION = (challengeName: string) =>
  `Want to start following the path towards your goal? Try this challenge ${challengeName}.`;
export const BELONG_GO_TO_APP_BUTTON_TEXT = 'Go To App';
export const BELONG_CHANGE_EMAIL_BUTTON_TEXT = 'Change Email';
